<script setup lang="ts">
	import { ref } from "vue";
	import SectionFooter from "~/components/sections/sectionFooter.vue";
	import SectionHeader from "~/components/sections/sectionHeader.vue";
	import SectionUserAccountTimeOut from "~/components/sections/sectionUserAccountTimeOut.vue";
	import { useAuthStore } from "~/store/auth";
	import { usePanelLayoutStore } from "~/store/main";
	import Logout from "public/images/logout.svg";
	import LayoutSidebarMenuItem from "~/components/layoutSidebarMenuItem.vue";
	import { isTimeOutStartEnd } from "~/utils";

	const authStore = useAuthStore();
	const isUserLogin = ref(false);
	const { panelMenuItems } = usePanelLayoutStore();
	isUserLogin.value = !!authStore.user;

	const { $client } = useNuxtApp();
	const isSubmitting = ref(false);
	const logout = async () => {
		if (isSubmitting.value) return;
		isSubmitting.value = true;
		try {
			const { success } = await $client.rpcAuth.logout.query();
			if (success) {
				authStore.logout();
				isUserLogin.value = false;
				navigateTo("/");
			} else {
				isSubmitting.value = false;
				console.error("Logout Error");
			}
		} catch (e) {
			isSubmitting.value = false;
			console.error(e);
		}
	};

	const route = useRoute();

	const isTimeOut = computed(() => {
		if (!authStore.user) return false;
		if (!authStore.userAccount) return false;
		if (authStore.userAccount.is_default_account) return false;
		if (!authStore.hasPin()) return false;
		if (
			!authStore.user.watch_limit_start_hour ||
			!authStore.user.watch_limit_end_hour
		)
			return false;
		return isTimeOutStartEnd(
			authStore.user?.watch_limit_start_hour,
			authStore.user?.watch_limit_end_hour,
		);
	});
</script>

<template>
	<div>
		<div v-if="!(isTimeOut && route.path != '/panel/accounts')">
			<header class="text-black sticky left-0 top-0 w-full h-16 z-50">
				<ClientOnly>
					<section-header />
				</ClientOnly>
			</header>

			<!-- Main -->
			<main>
				<!-- Sidebar -->
				<div class="flex justify-center md:justify-start">
					<div
						class="panel-menu"
						:class="[
							'shadow md:fixed relative z-10 md:ms-6 lg:ms-20 md:my-6 bg-grayBackground text-dark w-[calc(100%-32px)] md:w-64 transform transition rounded-2xl p-4 pb-2',
						]"
					>
						<nav class="h-full">
							<div class="overflow-y-auto h-full gap-4">
								<div
									v-for="(item, index) in panelMenuItems"
									:key="index"
									class="mb-2"
								>
									<LayoutSidebarMenuItem :item />
								</div>
								<div class="mb-2" @click="logout">
									<div>
										<button
											class="w-full group flex items-center justify-start gap-2 px-3 py-3 hover:bg-dark text-dark hover:text-white rounded-2xl font-normal cursor-pointer"
											type="button"
											aria-label="خروج از حساب کاربری"
											tabindex="0"
										>
											<Logout
												viewBox="0 0 24 24"
												class="stroke-dark group-hover:stroke-white w-6 h-8 flex justify-center items-center"
											></Logout>

											<span
												class="flex items-center pointer-events-none select-none"
											>
												خروج از حساب کاربری
											</span>
										</button>
									</div>
								</div>
							</div>
						</nav>
					</div>
				</div>

				<slot :key="isUserLogin"></slot>
			</main>
			<footer
				class="px-6 sm:px-6 lg:px-20 bg-dark flex justify-center items-center text-white py-1 w-full"
				dir="rtl"
			>
				<section-footer></section-footer>
			</footer>
		</div>
		<section-user-account-time-out v-else> </section-user-account-time-out>
	</div>
</template>

<style></style>
